import React, {useEffect, useRef, useState} from "react"
import {useNavigate} from "react-router-dom"
import IconButton from "../../generic/buttons/IconButton"
import {useAppDispatch, useAppSelector} from "../../../hooks/redux"
import {fetchNotifications, notificationRead} from "../../../store/actions/notificationActions"
import { useOnClickOutside } from 'usehooks-ts'
import Loading from "../Loading/Loading"
import useSound from "use-sound"
import sfxSound from "../../../assets/sounds/sfx-tady.mp3"
import classes from "./Notification.module.scss"

export default function Notification () {

  const dispatch = useAppDispatch()
  const {isAuthenticated} = useAppSelector(state => state.auth)
  const {isLoading, countNew, list} = useAppSelector(state => state.notification)
  const [listShown, toggleList] = useState(false)
  const ref = useRef(null)
  const navigate = useNavigate()
  const [play] = useSound(sfxSound);
  const [currentCountNew, setCurrentCountNew] = useState(0)

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchNotifications())
    }
  }, [dispatch])

  useEffect(() => {
    if (countNew > currentCountNew) {
      setCurrentCountNew(countNew)
      console.log(`ding`)
      play()
    }
  }, [countNew])

  useEffect(() => {
    if (isAuthenticated) {
      const timer = setInterval(() => {
        dispatch(fetchNotifications())
      }, 30000)
    }
  }, [dispatch, isAuthenticated])

  const notificationClickHandler = async (request_id: number, notification_id: number, read: boolean) => {
    toggleList(false)
    navigate(`/order/${request_id}`)

    if (!read) {
      const isRead = await dispatch(notificationRead(notification_id))
      if (isRead) {
        dispatch(fetchNotifications())
        setCurrentCountNew(countNew - 1)
      }
    }
  }

  const toggleClickHandler = () => {
    toggleList(!listShown)
  }

  const handleClickOutside = () => {
    toggleList(false)
  }

  useOnClickOutside(ref, handleClickOutside)

  const dataList = !isLoading && list && !!list.length && list.map(item =>
    <div
      className={[classes.item, !item.read && classes.item_unread].join(" ")}
      key={item.id}
      onClick={() => notificationClickHandler(item.request_id, item.id, item.read)}
    >
      <div className={classes.item_text}>{item.text}</div>
      <div className={classes.item_date}>{item.created_at}</div>
    </div>
  )

  const emptyList = !isLoading && !list.length && <div className={classes.list_empty}>Пока нет уведомлений</div>

  return (
    <div className={classes.wrap} ref={ref}>
      <IconButton
        redMark={countNew > 0}
        color={"white"}
        icon={'bell'}
        onClick={() => toggleClickHandler()}
      />
      {listShown &&
        <div className={classes.dropdown}>
          <div className={classes.title}>Уведомления</div>
          <div className={classes.list}>
            {isLoading && <Loading/>}
            {dataList}
            {emptyList}
          </div>
        </div>
      }
    </div>
  )
}